import Vue from 'vue'
import Router from 'vue-router'
//路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
      Router.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => err)
      }
Vue.use(Router)

export default new Router({
  mode:'history',
  linkActiveClass:"active",
  routes: [
    {
      path: '/',
      component: ()=> import('@/components/index'),
      redirect: '/home',
      children:[
        {
          path: '/index',
          name: 'Index',
          component: () => import('@/components/index'),
        },
        {
          path: '/home',
          name: 'Home',
          component: ()=> import('@/components/pages/home'),
          meta:{
            title:'aaa',
            content:{
              keywords:'bbb',
              description:'ccc'
            }
          }
        },
        {
          path: '/jobWanted',
          name: 'JobWanted',
          component: ()=> import('@/components/pages/jobWanted'),
        },
        {
          path: '/service',
          name: 'Service',
          component: ()=> import('@/components/pages/service'),
          children:[
              {
                path: '/service/recruitment',
                name: 'Recruitment',
                component: ()=> import('@/components/pages/service/recruitment')
              },
              {
                path: '/service/personnel',
                name: 'Personnel',
                component: ()=> import('@/components/pages/service/personnel')
              },
              {
                path: '/service/flexible',
                name: 'Flexible',
                component: ()=> import('@/components/pages/service/flexible'),
                children:[
                  {
                    path:'/service/flexible/flexiblechildren/flexblechildren1',
                    name:'Flexblechildren1',
                    component:()=>import('@/components/pages/service/flexible/flexiblechildren/flexblechildren1')
                  },
                  {
                    path:'/service/flexible/flexiblechildren/flexblechildren2',
                    name:'Flexblechildren2',
                    component:()=>import('@/components/pages/service/flexible/flexiblechildren/flexblechildren2')
                  },
                  {path:'/service/flexible',redirect:'/service/flexible/flexiblechildren/flexblechildren1'},
                ]
              },
              {path:'/service',redirect:'/service/recruitment'},
          ]
        },
        {
          path: '/product',
          name: 'Product',
          component: ()=> import('@/components/pages/product'),
          children:[
            {
              path: '/product/prorecruitment',
              name: 'Prorecruitment',
              component: ()=> import('@/components/pages/product/Prorecruitment')
            },
            {
              path: '/product/promployment',
              name: 'Promployment',
              component: ()=> import('@/components/pages/product/Promployment')
            },
            {path:'/product',redirect:'/product/prorecruitment'},
          ],
        },
        {
          path: '/about',
          name: 'About',
          component: ()=> import('@/components/pages/about')
        },
        {path:'/',redirect:'/home'},
      ]
    },
    {path:'*',redirect:'/'},
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js